// User.jsx
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { EyeFill, PenFill, XCircle } from "react-bootstrap-icons";
import { headers, url } from "../../utils/const";

// ✅ Nunca rompe React: convierte cualquier cosa a texto renderizable
const safe = (v) => {
  if (v === null || v === undefined) return "";
  const t = typeof v;
  if (t === "string" || t === "number" || t === "boolean") return String(v);
  if (Array.isArray(v)) return v.map(safe).filter(Boolean).join(", ");
  if (t === "object") {
    if ("name" in v) return safe(v.name);
    if ("userName" in v) return safe(v.userName);
    if ("user" in v) return safe(v.user);
    if ("_id" in v) return safe(v._id);
    try {
      return JSON.stringify(v);
    } catch {
      return "";
    }
  }
  return "";
};

const getByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
};

// ✅ Para filtrar “por cualquier campo”: serializa de forma segura (con límite)
const rowToSearchText = (row) => {
  const seen = new Set();
  const walk = (x, depth) => {
    if (x === null || x === undefined) return "";
    const t = typeof x;
    if (t === "string" || t === "number" || t === "boolean") return String(x);
    if (Array.isArray(x)) return depth <= 0 ? "" : x.map((i) => walk(i, depth - 1)).join(" ");
    if (t === "object") {
      if (seen.has(x)) return "";
      seen.add(x);
      if (depth <= 0) return safe(x);
      return Object.values(x)
        .map((v) => walk(v, depth - 1))
        .join(" ");
    }
    return "";
  };
  return walk(row, 2).toLowerCase();
};

function User() {
  const [show, setShow] = useState(false);
  const [showModalPoint, setShowModalPoint] = useState(false);

  const [user, setUser] = useState({
    name: "",
    userName: "",
    level: "4",
    phone: "",
    password: "",
    confirmePassword: "",
  });

  const [points, setPoints] = useState([]);
  const [point, setPoint] = useState("");
  const [userAsignPoint, setuserAsignPoint] = useState("");
  const [listUser, setListUser] = useState([]);

  // ✅ filtro + orden
  const [q, setQ] = useState("");
  const [sortBy, setSortBy] = useState(""); // path tipo "name", "customer.name", "point.name"
  const [sortDir, setSortDir] = useState("asc"); // "asc" | "desc"

  // Columnas (la clave define el path para ordenar)
  const columns = useMemo(
    () => [
      { key: "#", label: "#", sortable: false },
      { key: "name", label: "Nombre", sortable: true },
      { key: "user", label: "Usuario", sortable: true },
      { key: "level", label: "Nivel", sortable: true },
      { key: "customer.name", label: "Consorcio", sortable: true }, // intenta por name si es objeto
      { key: "phone", label: "Contacto", sortable: true },
      { key: "point.name", label: "Puntos", sortable: true },
      { key: "activated", label: "Estado", sortable: true },
      { key: "accion", label: "Accion", sortable: false },
    ],
    []
  );

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    const level = localStorage.getItem("level");
    if (!sessionId || !level || (level !== "1" && level !== "2")) return;

    fetch(`${url}/user`, { method: "GET", headers })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setListUser(data);
        else setListUser([]);
      })
      .catch((err) => console.error("Error cargando usuarios:", err));
  }, []);

  const Onchange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => {
      if (name === "user") return { ...prev, userName: value }; // ✅
      return { ...prev, [name]: value };
    });
  };

  const OnChangePoint = (e) => setPoint(e.target.value);

  const AsignPoint = () => {
    fetch(`${url}/user`, {
      method: "PUT",
      headers,
      body: JSON.stringify({ point, userAsign: userAsignPoint }),
    })
      .then((res) => res.json())
      .then(() => setShowModalPoint(false))
      .catch((err) => console.error("Error asignando punto:", err));
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleShowModalPoint = (level, userPoint) => {
    if (String(level) !== "4") return;

    fetch(`${url}/point`, { method: "GET", headers })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setPoints(data.map((z) => ({ id: z._id, name: z.name })));
          setuserAsignPoint(userPoint);
          setPoint(data?.[0]?.name || "");
        } else {
          setPoints([]);
          setPoint("");
        }
        setShowModalPoint(true);
      })
      .catch((err) => console.error("Error cargando puntos:", err));
  };

  const handleCloseModalPoint = () => setShowModalPoint(false);

  const Createuser = () => {
    fetch(`${url}/user`, {
      method: "POST",
      headers,
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setListUser(data);
          handleClose();
        }
      })
      .catch((err) => console.error("Error creando usuario:", err));
  };

  const DisaableUser = useCallback(async (code, nextState) => {
    try {
      await fetch(`${url}/user/active`, {
        method: "PUT",
        headers,
        body: JSON.stringify({ code, state: nextState }),
      });

      // ✅ reflejo inmediato en UI
      setListUser((prev) => prev.map((u) => (u._id === code ? { ...u, activated: nextState } : u)));
    } catch (e) {
      console.error("Error cambiando estado:", e);
    }
  }, []);

  // ✅ ordenar al click en TH
  const onHeaderSort = (key) => {
    const col = columns.find((c) => c.key === key);
    if (!col || !col.sortable) return;

    if (sortBy === key) {
      setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const sortArrow = (key) => {
    if (sortBy !== key) return "";
    return sortDir === "asc" ? " ▲" : " ▼";
  };

  // ✅ visibleRows: filtrar + ordenar
  const visibleRows = useMemo(() => {
    const rows = Array.isArray(listUser) ? listUser : [];

    const query = q.trim().toLowerCase();
    const filtered = !query ? rows : rows.filter((r) => rowToSearchText(r).includes(query));

    if (!sortBy) return filtered;

    const dir = sortDir === "asc" ? 1 : -1;

    const cmp = (a, b) => {
      const va = safe(getByPath(a, sortBy));
      const vb = safe(getByPath(b, sortBy));

      const na = Number(va);
      const nb = Number(vb);
      const bothNum = va !== "" && vb !== "" && !Number.isNaN(na) && !Number.isNaN(nb);

      let res = 0;
      if (bothNum) res = na - nb;
      else res = va.localeCompare(vb, undefined, { numeric: true, sensitivity: "base" });

      return res * dir;
    };

    return filtered.slice().sort(cmp);
  }, [listUser, q, sortBy, sortDir]);

  return (
    <div>
      <div className="p-2 m-2 justify-content-end row col-12 card-header">
        <div className="col-4">
          <button onClick={handleShow} className="btn btn-primary pt-2 mt-2">
            Crear Nuevo Usuario
          </button>
        </div>
      </div>

      {/* ✅ Filtro + info */}
      <div className="d-flex gap-2 align-items-center mb-2 flex-wrap px-2">
        <input
          className="form-control"
          style={{ maxWidth: 420 }}
          placeholder="Filtrar por cualquier campo…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />

        <div className="ms-auto small text-muted">
          Mostrando {visibleRows.length} de {listUser.length}
          {sortBy ? ` · Orden: ${sortBy} (${sortDir})` : ""}
        </div>

        {(q || sortBy) && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => {
              setQ("");
              setSortBy("");
              setSortDir("asc");
            }}
          >
            Limpiar
          </button>
        )}
      </div>

      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  onClick={() => onHeaderSort(c.key)}
                  style={{
                    cursor: c.sortable ? "pointer" : "default",
                    userSelect: "none",
                    whiteSpace: "nowrap",
                  }}
                  title={c.sortable ? "Click para ordenar" : undefined}
                >
                  {c.label}
                  {c.sortable && sortArrow(c.key)}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {visibleRows.map((z, index) => {
              const userId = z?._id || `${index}`;
              const userLabel = safe(z?.user || z?.userName);
              const customerLabel = safe(z?.customer?.name || z?.customer);
              const pointName = safe(z?.point?.name || z?.point);

              return (
                <tr key={userId}>
                  <td>{index + 1}</td>
                  <td>{safe(z?.name)}</td>
                  <td>{userLabel}</td>
                  <td>{safe(z?.level)}</td>
                  <td>{customerLabel}</td>
                  <td>{safe(z?.phone)}</td>

                  <td
                    onClick={() => handleShowModalPoint(z?.level, z?.user || z?.userName)}
                    style={{ cursor: String(z?.level) === "4" ? "pointer" : "default" }}
                  >
                    {String(z?.level) === "4" ? pointName : ""}{" "}
                    <PenFill hidden={String(z?.level) !== "4"} />
                  </td>

                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={!!z?.activated}
                        onChange={() => DisaableUser(z?._id, !z?.activated)}
                      />
                    </div>
                  </td>

                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="pr-1 mr-1">
                            <button className="btn btn-primary m-1" onClick={() => DisaableUser(z?._id, !z?.activated)}>
                              <EyeFill />
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn btn-warning m-1"
                              disabled={localStorage.getItem("level") !== "1"}
                              onClick={() => DisaableUser(z?._id, !z?.activated)}
                            >
                              <PenFill />
                            </button>
                          </td>
                          <td>
                            <button
                              className="btn btn-danger m-1"
                              disabled={localStorage.getItem("level") !== "1"}
                              onClick={() => DisaableUser(z?._id, false)}
                            >
                              <XCircle />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal crear usuario */}
      <Modal show={show} onHide={handleClose} className="bg-info">
        <Modal.Header closeButton>
          <Modal.Title>Crear Nuevo Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 row form-group">
            <div className="col-6 form-group">
              <div className="col-12">
                <label>Nombre:</label>
              </div>
              <div className="col-12">
                <input type="text" className="form-control" name="name" value={user.name} onChange={Onchange} />
              </div>
            </div>

            <div className="col-6 form-group">
              <div className="col-12">
                <label>Usuario:</label>
              </div>
              <div className="col-12">
                <input type="text" className="form-control" name="user" value={user.userName} onChange={Onchange} />
              </div>
            </div>

            <div className="col-6 form-group">
              <div className="col-12">
                <label>Telefono</label>
              </div>
              <div className="col-12">
                <input type="text" className="form-control" name="phone" value={user.phone} onChange={Onchange} />
              </div>
            </div>

            <div className="for-group col-6">
              <div className="col-12">
                <label>Seleccione el Rol</label>
              </div>
              <div className="col-12">
                <select className="form-select" name="level" value={user.level} onChange={Onchange}>
                  <option value="1">Admin</option>
                  <option value="2">Consorcio</option>
                  <option value="3">Soporte Tecnico</option>
                  <option value="4">Punto de Venta</option>
                </select>
              </div>
            </div>

            <div className="col-6 form-group">
              <div className="col-12">
                <label>Password:</label>
              </div>
              <div className="col-12">
                <input type="password" className="form-control" name="password" value={user.password} onChange={Onchange} />
              </div>
            </div>

            <div className="col-6 form-group">
              <div className="col-12">
                <label>Repetir Password:</label>
              </div>
              <div className="col-12">
                <input type="password" className="form-control" name="confirmePassword" value={user.confirmePassword} onChange={Onchange} />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={Createuser}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal asignar punto */}
      <Modal show={showModalPoint} onHide={handleCloseModalPoint} size="lg" className="bg-info">
        <Modal.Header closeButton>
          <Modal.Title>Asignar Punto</Modal.Title>
        </Modal.Header>

        <form>
          <Modal.Body>
            <div className="col-12 row justify-content-center">
              <div className="col-10 form-group">
                <div className="col-12">
                  <label>{`Asignar Punto De Venta a: ${safe(userAsignPoint)}`}</label>
                </div>
                <div className="col-12">
                  <label>Seleccione Un Punto De Venta</label>
                  <select className="form-control" value={point} onChange={OnChangePoint}>
                    <option value="">No Asignado</option>
                    {points.map((p) => (
                      <option key={p.id} value={safe(p.name)}>
                        {safe(p.name)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" onClick={handleCloseModalPoint}>
              Close
            </button>
            <button type="button" onClick={AsignPoint}>
              Save Changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}

export default User;
